import { Factory, trait } from 'miragejs'
import Chance from 'chance'

const chance = new Chance()

export default Factory.extend({
  ts() {
    return chance.date().toISOString()
  },
  device: '00:04:4b:a5:76:6f',
  deviceId: '78',
  stage: 'Trim Waste',
  reason: 'Some reason',
  type: 'other',
  guid: 57846175,

  afterImageId: 5153772,
  afterImage:
    'https://s3.amazonaws.com/c76a090f-0e84-44f4-98bf-fe0469e163cd/00:04:4b:a5:76:6f/bgvgdsbg1u5000aic9j0',

  withImages: trait({
    afterCreate(model, server) {
      server.create('image', { eventId: model.id, isBefore: true })
      server.create('image', { eventId: model.id, isAfter: true })
      server.createList('image', 3, { eventId: model.id })
    }
  })
})

// Example full payload

// {
//   "id": 372331,
//   "uuid": "7d7cf7b1-ac17-41a2-9a75-843951b41709",
//   "guid": 57846175,
//   "stageGuid": 36362,
//   "stage": "Trim Waste",
//   "reasonGuid": 36628,
//   "reason": "Trim Waste",
//   "foodGuid": 11582166,
//   "food": "Organic fresh porridge",
//   "device": "00:04:4b:a5:76:6f",
//   "deviceId": 78,
//   "originalLabel": "Organic fresh porridge",
//   "originalLabelGuid": 0,
//   "actualLabel": "",
//   "actualLabelGuid": 0,
//   "beforeImageId": 5153771,
//   "beforeImage": "https://s3.amazonaws.com/c76a090f-0e84-44f4-98bf-fe0469e163cd/00:04:4b:a5:76:6f/bgvgdsbg1u5000aic9i0",
//   "afterImageId": 5153772,
//   "afterImage": "https://s3.amazonaws.com/c76a090f-0e84-44f4-98bf-fe0469e163cd/00:04:4b:a5:76:6f/bgvgdsbg1u5000aic9j0",
//   "approved": -1,
//   "weightG": 3970,
//   "cost": 6.749,
//   "ts": "2019-01-16T10:17:33.763Z",
//   "type": "other",
//   "tsStart": "2019-01-16T10:17:42.784Z",
//   "tsEnd": "2019-01-16T10:17:33.763Z",
//   "durationMs": -9021,
//   "menuId": 11220,
//   "installationId": "21"
// }
